import React, { useState,useEffect} from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { ApiUrl } from "../../../ApiUrl";

const App = ({ goToTab, prefilledCourses, setLanguageDataInParent }) => {
  const [formData, setFormData] = useState({
    courseName: "",
    coursePlace: "",
    dateFrom: "",
    dateTo: "",
    validUpTo: "",
    grade: "",
  });

  const [tableData, setTableData] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});

  const isFutureDate = (value) => {
    if (!value) return false;
    const enteredDate = new Date(value);
    if (Number.isNaN(enteredDate.getTime())) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return enteredDate > today;
  };

  const isValidGradePercent = (value) => {
    if (value === "" || value === null || value === undefined) {
      return true;
    }

    const numeric = Number(value);
    return !Number.isNaN(numeric) && numeric >= 0 && numeric <= 100;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "dateFrom" || name === "dateTo" || name === "validUpTo") {
      setValidationErrors((prev) => ({
        ...prev,
        [name]: isFutureDate(value) ? "This date cannot be in the future." : "",
      }));
    }

    if (name === "grade") {
      const sanitized = String(value).replace(/[^0-9.]/g, "");

      if (sanitized === "") {
        setFormData((prevData) => ({
          ...prevData,
          grade: "",
        }));
        return;
      }

      const numeric = Number(sanitized);
      if (Number.isNaN(numeric) || numeric < 0 || numeric > 100) {
        alert("Grade % cannot be more than 100.");
        return;
      }

      setFormData((prevData) => ({
        ...prevData,
        grade: sanitized,
      }));
      return;
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleAdd = () => {
    if (!isValidGradePercent(formData.grade)) {
      alert("Grade % must be between 0 and 100.");
      return;
    }

    if (!formData.courseName || !formData.coursePlace || !formData.dateFrom || !formData.dateTo) {
      alert("Please fill Course Name, Course Place, Date From and Date To before adding.");
      return;
    }

    if (isFutureDate(formData.dateFrom) || isFutureDate(formData.dateTo)) {
      setValidationErrors({
        dateFrom: isFutureDate(formData.dateFrom)
          ? "This date cannot be in the future."
          : "",
        dateTo: isFutureDate(formData.dateTo)
          ? "This date cannot be in the future."
          : "",
      });
      return;
    }

    if (new Date(formData.dateTo) < new Date(formData.dateFrom)) {
      alert("Date To cannot be earlier than Date From.");
      return;
    }

    if (
      formData.validUpTo &&
      (isFutureDate(formData.validUpTo) || new Date(formData.validUpTo) < new Date(formData.dateFrom))
    ) {
      setValidationErrors({
        validUpTo: isFutureDate(formData.validUpTo)
          ? "This date cannot be in the future."
          : "",
      });
      return;
    }

    if (formData.grade) {
      const newSrNo = tableData.length + 1; // Auto-generated Sr.No

      const newRow = {
        srNo: newSrNo,
        ...formData,
      };

      setTableData([newRow, ...tableData]);

      setFormData({
        courseName: "",
        coursePlace: "",
        dateFrom: "",
        dateTo: "",
        validUpTo: "",
        grade: "",
      });
      setValidationErrors({});
    } else {
      alert("Please fill all fields before adding.");
    }
  };

  useEffect(() => {
    if (
      prefilledCourses &&
      Array.isArray(prefilledCourses) &&
      prefilledCourses.length > 0
    ) {
      const formatted = prefilledCourses.map((item, index) => ({
        srNo: index + 1,
        courseName: item.course_name || "",
        coursePlace: item.course_place || "",
        dateFrom: item.date_from || "",
        dateTo: item.date_to || "",
        validUpTo: item.valid_upto || "",
        grade: item.course_results || "",
      }));

      setFormData(formatted[0]); // Fill the first course into input fields
      setTableData(formatted.slice(1)); // Put the rest in table
    }
  }, [prefilledCourses]);


  // const handleNext = async () => {
  //   if (tableData.length === 0) {
  //     alert("Please add at least one course before proceeding.");
  //     return;
  //   }

  //   const employeeId = localStorage.getItem("employeeId");
  //   const createdBy = sessionStorage.getItem("userId");

  //   const payload = {
  //     created_by: parseInt(createdBy),
  //     course_details: tableData.map((row) => ({
  //       course_id: 0,
  //       course_name: row.courseName,
  //       course_place: row.coursePlace,
  //       date_from: row.dateFrom,
  //       date_to: row.dateTo,
  //       valid_upto: row.validUpTo,
  //       course_results: row.grade,
  //     })),
  //   };

  //   try {
  //     const response = await fetch(
  //       `${ApiUrl.apiurl}STAFF/registrationCourseCreateUpdate/${employeeId}/`,
  //       {
  //         method: "PUT",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(payload),
  //       }
  //     );

  //     if (response.ok) {
  //       const data = await response.json();
  //       console.log("API Response:", data);
  //       alert("Data saved successfully!");
  //       goToTab(6);
  //     } else {
  //       const errorData = await response.json();
  //       console.error("API Error:", errorData);
  //       alert("Failed to save data.");
  //     }
  //   } catch (error) {
  //     console.error("Network Error:", error);
  //     alert("Network error occurred.");
  //   }
  // };

  const handleNext = async () => {
    const hasInvalidGrade = [formData, ...tableData].some(
      (row) => !isValidGradePercent(row.grade)
    );

    if (hasInvalidGrade) {
      alert("Grade % must be between 0 and 100.");
      return;
    }

    const courseDetails = [formData, ...tableData]
      .filter((row) => row.courseName || row.coursePlace)
      .map((row) => ({
        course_id: 0,
        course_name: row.courseName,
        course_place: row.coursePlace,
        date_from: row.dateFrom,
        date_to: row.dateTo,
        valid_upto: row.validUpTo,
        course_results: row.grade,
      }));

    sessionStorage.setItem(
      "staff_registration_courses",
      JSON.stringify(courseDetails)
    );
    goToTab(6);
  };

  useEffect(() => {
    const courseDetails = [formData, ...tableData]
      .filter((row) => row.courseName || row.coursePlace)
      .map((row) => ({
        course_id: 0,
        course_name: row.courseName,
        course_place: row.coursePlace,
        date_from: row.dateFrom,
        date_to: row.dateTo,
        valid_upto: row.validUpTo,
        course_results: row.grade,
      }));

    sessionStorage.setItem(
      "staff_registration_courses",
      JSON.stringify(courseDetails)
    );
  }, [formData, tableData]);
  


  return (
    <div className="container-fluid my-4 px-3">
      {/* Courses */}
      <div className="table-responsive">
        <table
  className="table table-bordered"
  style={{
    tableLayout: "fixed",
    width: "100%",
  }}
>
          <thead className="thead-light">
            <tr>
  <th style={{ width: "8%" }}>Sr.No</th>
  <th style={{ width: "16%" }}>Course Name</th>
  <th style={{ width: "16%" }}>Course Place</th>
  <th style={{ width: "12%" }}>Date From</th>
  <th style={{ width: "12%" }}>Date To</th>
  <th style={{ width: "12%" }}>Valid Up To</th>
  <th style={{ width: "12%" }}>Grade%</th>
  <th style={{ width: "12%" }}>Action</th>
</tr>
          </thead>
          <tbody>
            {tableData.map((row, index) => (
              <tr key={index}>
                <td>{row.srNo}</td>
                <td>{row.courseName}</td>
                <td>{row.coursePlace}</td>
                <td>{row.dateFrom}</td>
                <td>{row.dateTo}</td>
                <td>{row.validUpTo}</td>
                <td>{row.grade}</td>
                <td>--</td>
              </tr>
            ))}
            <tr>
              <td>
                <input
                  type="text"
                  className="form-control"
style={{ height: "40px" }}
                  value={tableData.length + 1} // Auto-generated value
                  readOnly
                />
              </td>
              <td>
                <input
                  type="text"
                  className="form-control"
style={{ height: "40px" }}
                  name="courseName"
                  value={formData.courseName}
                  onChange={handleChange}
                />
              </td>
              <td>
                <input
                  type="text"
                  className="form-control"
style={{ height: "40px" }}
                  name="coursePlace"
                  value={formData.coursePlace}
                  onChange={handleChange}
                />
              </td>
              <td>
                <input
                  type="date"
                  className={`form-control ${validationErrors.dateFrom ? "is-invalid" : ""}`}
style={{ height: "40px" }}
                  name="dateFrom"
                  value={formData.dateFrom}
                  onChange={handleChange}
                />
                {validationErrors.dateFrom && (
                  <div className="invalid-feedback d-block">
                    {validationErrors.dateFrom}
                  </div>
                )}
              </td>
              <td>
                <input
                  type="date"
                  className={`form-control ${validationErrors.dateTo ? "is-invalid" : ""}`}
style={{ height: "40px" }}
                  name="dateTo"
                  value={formData.dateTo}
                  onChange={handleChange}
                />
                {validationErrors.dateTo && (
                  <div className="invalid-feedback d-block">
                    {validationErrors.dateTo}
                  </div>
                )}
              </td>
              <td>
                <input
                  type="date"
                  className={`form-control ${validationErrors.validUpTo ? "is-invalid" : ""}`}
style={{ height: "40px" }}
                  name="validUpTo"
                  value={formData.validUpTo}
                  onChange={handleChange}
                />
                {validationErrors.validUpTo && (
                  <div className="invalid-feedback d-block">
                    {validationErrors.validUpTo}
                  </div>
                )}
              </td>
              <td>
                <input
                  type="number"
                  className="form-control"
style={{ height: "40px" }}
                  name="grade"
                  min="0"
                  max="100"
                  step="0.01"
                  value={formData.grade}
                  onChange={handleChange}
                />
              </td>
              <td>
                <button
  className="btn btn-primary w-100"
  style={{ height: "40px" }}
  onClick={handleAdd}
>
                  Add
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="d-flex justify-content-between mb-3 mt-2"></div>
    </div>
  );
};

export default App;
